import { request } from '@tencent/ppd-base-libs';

export async function getHomepageInit(params) {
  return request.get('/cgi-bin/charity/homepage_init.fcgi', {
    params,
  });
}

export function getDonorQry(params) {
  return request.get('/cgi-bin/charity/donor_qry.fcgi', {
    params,
  });
}

export function orderReq(params) {
  return request.post('/cgi-bin/charity/order_req.fcgi', params);
}

export function getJssdkSign(params) {
  return request.get('/cgi-bin/charity/get_jssdk_sign.fcgi', {
    params,
  });
}

export function wxPayCallback(params) {
  return request.get('/cgi-bin/charity/wx_pay_callback.fcgi', {
    params,
  });
}

export function hisQry(params) {
  return request.get('/cgi-bin/charity/his_qry.fcgi', {
    params,
  });
}

export function detailQry(params) {
  return request.get('/cgi-bin/charity/detail_qry.fcgi', {
    params,
  });
}

export type QryUserInfoRes = {
  nickname: string;
  headimgurl: string;
};

// 查询用户头像昵称
export async function qryUserInfo(code: string): Promise<QryUserInfoRes> {
  return request.get('/cgi-bin/charity/user_info_qry.fcgi', {
    params: {
      code,
    }
  });
}
